/**
 * Dogsee loading: full-page loader + product/image placeholders using spinner.gif
 * Same concept as dogsee_us (pageloadspinner + lazy img with spinner.gif)
 */
(function () {
  var loaderUrl = document.body.getAttribute('data-dogsee-loader-url') || '';

  var skipNextLoader = false;
  try {
    skipNextLoader = sessionStorage.getItem('dogsee-skip-next-loader') === '1';
    if (skipNextLoader) {
      sessionStorage.removeItem('dogsee-skip-next-loader');
      document.documentElement.removeAttribute('data-dogsee-skip-loader');
    }
  } catch (e) {}

  var loaderMinShowMs = skipNextLoader ? 0 : 250; // Minimal visible loader duration for fast loading
  var loaderShownAt = window.dogseeLoaderShownAt || Date.now();

  // Skip loader for back/forward navigation
  var isBackForward = (window.performance && window.performance.getEntriesByType) ?
    window.performance.getEntriesByType('navigation')[0]?.type === 'back_forward' : false;

  if (isBackForward) {
    loaderMinShowMs = 0; // Don't show loader on back/forward navigation
  }

  function hidePageLoader() {
    var el = document.getElementById('dogsee-page-loader');
    if (!el) return;
    var loaderEl = el;
    var elapsed = Date.now() - loaderShownAt;
    var wait = Math.max(0, loaderMinShowMs - elapsed);
    if (wait > 0) {
      setTimeout(function () {
        loaderEl.setAttribute('hidden', '');
      }, wait);
    } else {
      loaderEl.setAttribute('hidden', '');
    }
  }

  // Show loader at least 3 seconds, then hide after DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hidePageLoader);
  } else {
    hidePageLoader();
  }

  function addImagePlaceholders() {
    if (!loaderUrl) return;

    var selectors = [
      '.card-gallery img',
      '.product-media__image',
      '.product-media .deferred-media__poster-image',
      '.card-gallery .product-media-container img'
    ];

    selectors.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (img) {
        if (img.hasAttribute('data-dogsee-placeholder-done')) return;
        // Collection/search grids: injecting siblings + MutationObserver re-runs caused visible CLS
        // (badges/images jumping) on first paint. Cards already use lazy loading; skip overlay here.
        if (
          img.closest(
            '#ResultsList, .product-grid-container, ul.product-grid, .section-resource-list, product-recommendations, .resource-list__carousel'
          )
        ) {
          img.setAttribute('data-dogsee-placeholder-done', '1');
          return;
        }

        img.setAttribute('data-dogsee-placeholder-done', '1');

        var parent = img.parentElement;
        if (!parent || parent === document.body) return;

        if (getComputedStyle(parent).position === 'static') {
          parent.style.position = 'relative';
        }

        var placeholder = document.createElement('div');
        placeholder.className = 'dogsee-img-placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        placeholder.style.backgroundImage = 'url(' + loaderUrl + ')';
        parent.insertBefore(placeholder, img);

        var image = /** @type {HTMLImageElement} */ (img);
        if (image.complete && image.naturalWidth) {
          placeholder.setAttribute('hidden', '');
        } else {
          image.addEventListener('load', function onLoad() {
            placeholder.setAttribute('hidden', '');
            image.removeEventListener('load', onLoad);
          });
          image.addEventListener('error', function onError() {
            placeholder.setAttribute('hidden', '');
            image.removeEventListener('error', onError);
          });
        }
      });
    });
  }

  /**
   * @param {() => void} fn
   */
  function runWhenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  runWhenReady(function () {
    // For grouped-product switch navigations, avoid extra placeholder overlays
    // that can look like UI flicker right after page reveal.
    if (skipNextLoader) return;

    addImagePlaceholders();

    // Dynamically added content (e.g. sections, quick view)
    var observer = new MutationObserver(function (mutations) {
      var shouldRun = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (shouldRun) addImagePlaceholders();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  });
})();
